export function transitionStandard(property) {
  return `
    -webkit-transition: ${property} 0.1s cubic-bezier(0.4, 0.0, 0.2, 1);
    -o-transition: ${property} 0.1s cubic-bezier(0.4, 0.0, 0.2, 1);
    transition: ${property} 0.1s cubic-bezier(0.4, 0.0, 0.2, 1);
  `;
}
